import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from 'modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from 'modules/search/types/SearchRefinementVariant';
import { EMPLOYMENT_TYPE_CHECKBOX_OPTIONS } from 'utils/constants/general/employmentTypes';

type Props = {
  variant?: SearchRefinementVariant;
};
export function EmploymentTypeFacet({ variant = 'dropdown' }: Props) {
  const selectedFacetValues = useSearchFacetSelectedValues('jobType');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="jobType"
      icon="hammer"
      label={
        <>
          {getText('Job Type')}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="jobType"
        initialValue={selectedFacetValues}
        options={EMPLOYMENT_TYPE_CHECKBOX_OPTIONS()}
      />
    </FacetVariant>
  );
}
